import {
    buildQuadrant,
    flip,
    increment,
    maybeInvert,
    positionToCoords
} from './utils'

const pickRandom = values => values[Math.floor(Math.random() * values.length)]

const nextColorState = (config, getRandomColorStops) => {
    if (config.lockMode === 'colors') {
        return {
            colorStops: config.colorStops,
            isGradientInverted: config.isGradientInverted
        }
    }

    return getRandomColorStops(config.colorStops)
}

export const advanceSingle = ({config, dimensions, getRandomColorStops}) => {
    const colorState = nextColorState(config, getRandomColorStops)

    if (config.lockMode === 'layout') {
        return {
            ...config,
            ...colorState
        }
    }

    const position = Math.floor(Math.random() * (dimensions * dimensions))
    const {x, y} = positionToCoords(position, dimensions)
    const values = [...config.values]

    values[position] = increment(config.values[position])

    if (x !== y) {
        const mirror = (x * dimensions) + y
        values[mirror] = flip(values[position])
    }

    return {
        ...config,
        ...colorState,
        values
    }
}

export const advanceAll = ({config, dimensions, getRandomColorStops}) => {
    const colorState = nextColorState(config, getRandomColorStops)

    return {
        ...config,
        ...colorState,
        values: config.lockMode === 'layout' ? config.values : buildQuadrant(dimensions)
    }
}

export const advanceLayout = ({config, dimensions, getRandomColorStops, layouts}) => {
    const layoutSet = layouts[dimensions]
    if (!layoutSet) {
        return config
    }

    const colorState = nextColorState(config, getRandomColorStops)
    const labels = Object.keys(layoutSet)
    if (!labels.length) {
        return {
            ...config,
            ...colorState
        }
    }

    if (config.lockMode === 'layout') {
        const label = config.currentLayoutLabel && layoutSet[config.currentLayoutLabel]
            ? config.currentLayoutLabel
            : pickRandom(labels)

        return {
            ...config,
            currentLayoutLabel: label,
            ...colorState,
            values: layoutSet[label]
        }
    }

    const label = pickRandom(labels)
    return {
        ...config,
        currentLayoutLabel: label,
        ...colorState,
        values: maybeInvert(layoutSet[label])
    }
}

export const advanceSequence = ({config, dimensions, getRandomColorStops, sequence}) => {
    const colorState = nextColorState(config, getRandomColorStops)

    if (config.lockMode === 'layout') {
        return {
            ...config,
            ...colorState
        }
    }

    const sequenceSet = sequence[dimensions]
    if (!Array.isArray(sequenceSet) || !sequenceSet.length) {
        return {
            ...config,
            ...colorState
        }
    }

    const sequenceIndex = (config.sequenceIndex + 1) % sequenceSet.length
    return {
        ...config,
        ...colorState,
        sequenceIndex,
        values: sequenceSet[sequenceIndex]
    }
}

export const selectLayoutByLabel = ({config, label, layouts}) => {
    const layoutSet = layouts[config.dimensions]
    if (!layoutSet || !layoutSet[label]) {
        return config
    }

    return {
        ...config,
        currentLayoutLabel: label,
        values: layoutSet[label]
    }
}
